// exclude-from-index
import React from 'react';
import { Spinner } from '../../../Utility/Spinner';
import { VerticalSpacing } from '../../../Utility/VerticalSpacing';
import { SpinnerWrapper } from './Loading.styles';

function Loading() {
  return (
    <VerticalSpacing>
      <SpinnerWrapper>
        <Spinner />
      </SpinnerWrapper>
    </VerticalSpacing>
  );
}

export default Loading;
